module.exports = __webpack_public_path__ + "img/RCCN-LOGO-WHITE1.7385ee17.png";